import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Rolepermission } from 'src/app/model/rolepermission.model';
import { AddfoodvendorService } from 'src/app/services/addfoodvendor.service';
import { RolepermissionService } from 'src/app/services/rolepermission.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-role-permission',
  templateUrl: './role-permission.component.html',
  styleUrls: ['./role-permission.component.scss']
})
export class RolePermissionComponent implements OnInit {

  public rolepermission = new Rolepermission();
  private subscriptions = new Subscription();

  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;
  totalCount;
  displayCount;
  mainModuleList: any[] = [];
  newmainModuleList: any[] = [];
  newmainModuleListReported = [];
  newmainModuleListHide = [];
  moduleDeepCopy: any;
  newMainModules: any;
  moduleTempNew: any;
  selectedModuleFilterName: any;
  multiSelectGroup: any;
  multiSelectGroupFilter: any;
  searchReviewList = [];
  searchGroup: string = '';
  keyWord: any;
  isHide: any;
  mainUserRoleList: any[] = [];
  newmainUserRoleList: any[] = [];
  userRoleDeepCopy: any;
  newMainUserRoles: any;
  userRoleTempNew: any;
  mainRolePermissionList = [];
  newmainRolePermissionList = [];
  userRolePermissionDeepCopy: any;
  newMainRolesPermission: any;
  userRolePermissionTempNew: any;
  selectedRoleArray = [];
  selectedPermissionArray = [];
  selectedModuleFilterId = 1;
  selectedSingleRoleId: any;
  finalSubmissionArray = [];
  selectedRoleSortName: any;
  searchGroupSort: string = '';
  mainRoleLatestTypes = [];
  multiSelectGroupSort: any;
  isDesc: boolean = false;
  column: string = 'userRoleName';
  getPermissionDataModuleWise = [];
  roleHasPermission = [];
  roleHasEmptyPermission = [];
  finalSubmissionArrayForRole = [];
  uniqueUserRolePermissionId: any;
  newmainRolePermissionListFiltred = [];
  disabledPermission: any;
  newDisabledArray: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodvendorService: AddfoodvendorService,
    private rolepermissionService: RolepermissionService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    this.getTheLatestOldestFilter();
    this.getTheModuleList();
    this.getTheUserRoleList();
    this.getThePermissionTypeList();
    this.getDisabledModuleId();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavFoodCourt');
    this.subscriptions.unsubscribe();
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverReceived(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      if (this.multiSelectGroup == 'All') {
        this.newmainUserRoleList = this.mainUserRoleList;
      } else {
        if (this.searchReviewList.length > 0) {
          this.newmainUserRoleList = this.searchReviewList;
        } else {
          this.newmainUserRoleList = this.mainUserRoleList;
        }
      }
      this.totalRows = this.newmainUserRoleList?.length;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    this.newmainUserRoleList = this.mainUserRoleList.filter((item: { userRoleName: any }) => {
      if (!item || !item.userRoleName) return false;
      return item.userRoleName.toLowerCase().includes(searchLower);
    });
    this.totalRows = this.newmainUserRoleList?.length;
  }

  getFilteredModuleList(): any[] {
    if (!this.newmainModuleList || !Array.isArray(this.newmainModuleList)) {
      return [];
    }
    if (!this.searchGroup || this.searchGroup === '') {
      return this.newmainModuleList;
    }
    const searchLower = this.searchGroup.toLowerCase();
    return this.newmainModuleList.filter((item: any) => {
      if (!item || !item.moduleName) return false;
      return item.moduleName.toLowerCase().includes(searchLower);
    });
  }

  handelReviewList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  getTheModuleList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.rolepermissionService.getModuleList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainModuleList = res?.list;
        this.newmainModuleList = res?.list;
        console.log(this.newmainModuleList);
        this.newMainModules = res?.list;
        this.moduleDeepCopy = JSON.parse(JSON.stringify(res?.list));
        this.moduleTempNew = res?.list;
        this.totalRows = res?.list.length;
        this.selectedModuleFilterName = this.newmainModuleList[0].moduleName;
        this.selectedModuleFilterId = this.newmainModuleList[0].moduleId;
      } else {
        this.mainModuleList = [];
        this.newmainModuleList = [];
        this.totalRows = 0;
      }
    });

    console.log(this.mainModuleList);
  }

  getTheUserRoleList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.rolepermissionService.getUserRoleList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainUserRoleList = res?.list;
        console.log(this.mainUserRoleList);
        // this.newmainSurveyList = res?.list;
        this.newmainUserRoleList = res?.list;
        this.newMainUserRoles = res;
        this.userRoleDeepCopy = JSON.parse(JSON.stringify(res));
        this.userRoleTempNew = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainUserRoleList = [];
        this.newmainUserRoleList = [];
        this.totalRows = 0;
      }
    });

    // for (var i = 0; i < this.newmainUserRoleList?.length; i++) {
    //   this.newmainUserRoleList[i].isSelected = false;
    // }

    this.newmainUserRoleList = this.newmainUserRoleList.map(permission => ({
      ...permission,
      isSelected: false
    }));

    console.log(this.newmainUserRoleList);
  }

  isAllSelectedRole(item: any) {
    console.log(item);
    // if (item.isSelected === true) {
    //   this.selectedRoleArray.push(item.userRolePermissionId);
    // } else {
    //   this.selectedRoleArray = this.selectedRoleArray.filter(e => e !== item.userRolePermissionId);
    // }
    this.selectedSingleRoleId = item.userRolePermissionId;
    this.uniqueUserRolePermissionId = item.userRolePermissionId;
    console.log(this.uniqueUserRolePermissionId);
    // item.isSelected = !item.isSelected;

    console.log(this.getPermissionDataModuleWise);
    const filteredItem = this.getPermissionDataModuleWise.find(item => item.userRolePermissionId === this.selectedSingleRoleId);
    console.log(filteredItem);

    if (filteredItem.permissionType === null) {
      filteredItem.permissionType = [];
    }

    const existingObj = this.finalSubmissionArrayForRole.find(obj => obj.userRolePermissionId === filteredItem.userRolePermissionId);

    //if (!existingObj) {
    this.finalSubmissionArrayForRole.push(filteredItem);
    //}

    // this.finalSubmissionArrayForRole.push(filteredItem);
    console.log(this.finalSubmissionArrayForRole);
    console.log(this.newmainRolePermissionListFiltred);


    if (filteredItem.permissionType != null && filteredItem.permissionType.length > 0) {
      // const result = this.roleHasPermission.join(",").split(',').map(Number);
      const result = filteredItem.permissionType;
      console.log(result);
      this.newmainRolePermissionList.forEach(day => {
        // Check if the id exists in providedArray
        if (result.includes(day.permissionTypeId)) {
          // If yes, set selected to true
          day.isSelected = true;
        } else {
          // If no, set selected to false
          day.isSelected = false;
        }
        console.log(day);
      });
      this.selectedPermissionArray = filteredItem.permissionType;
      console.log(this.selectedPermissionArray);
    } else {
      this.newmainRolePermissionList = this.newmainRolePermissionList.map(permission => ({
        ...permission,
        isSelected: false
      }));
      this.selectedPermissionArray = [];
    }
  }

  isAllSelectedPermission(item: any) {
    console.log(item);
    if (item.isSelected === true) {
      this.selectedPermissionArray.push(item.permissionTypeId);
    } else {
      this.selectedPermissionArray = this.selectedPermissionArray.filter(e => e !== item.permissionTypeId);
    }
    console.log(this.selectedPermissionArray); //finalSubmissionArrayForRole //uniqueUserRolePermissionId
    // item.isSelected = !item.isSelected;

    this.finalSubmissionArrayForRole = this.finalSubmissionArrayForRole.map(obj => {
      if (obj.userRolePermissionId === this.uniqueUserRolePermissionId) {
        return { ...obj, permissionType: this.selectedPermissionArray };
      }
      return obj;
    });
    console.log(this.finalSubmissionArrayForRole);

    // this.getPermissionDataModuleWise = this.finalSubmissionArrayForRole.map(obj => {
    //   if (obj.userRolePermissionId === this.uniqueUserRolePermissionId) {
    //     return { ...obj, permissionType: this.selectedPermissionArray };
    //   }
    //   return obj;
    // });

    this.getPermissionDataModuleWise = this.getPermissionDataModuleWise.map(obj => {
      if (obj.userRolePermissionId === this.uniqueUserRolePermissionId) {
        obj.permissionType = this.selectedPermissionArray;
      }
      return obj;
    });
    console.log(this.getPermissionDataModuleWise);

    // this.newmainRolePermissionListFiltred = this.newmainRolePermissionList.filter(obj => this.selectedPermissionArray.includes(obj.permissionTypeId));
    // console.log(this.newmainRolePermissionListFiltred);
  }

  getThePermissionTypeList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.rolepermissionService.getPermissionList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainRolePermissionList = res?.list;
        console.log(this.mainRolePermissionList);
        // this.newmainSurveyList = res?.list;
        this.newmainRolePermissionList = res?.list;
        this.newMainUserRoles = res;
        this.userRolePermissionDeepCopy = JSON.parse(JSON.stringify(res));
        this.userRolePermissionTempNew = res?.list;
        this.totalRows = res?.list.length;
        this.getPermissionModuleWise();
      } else {
        this.mainRolePermissionList = [];
        this.newmainRolePermissionList = [];
        this.totalRows = 0;
      }
    });

    // for (var i = 0; i < this.newmainRolePermissionList?.length; i++) {
    //   this.newmainRolePermissionList[i].isSelected = false;
    // }

    this.newmainRolePermissionList = this.newmainRolePermissionList.map(permission => ({
      ...permission,
      isSelected: false
    }));

    console.log(this.newmainRolePermissionList);
  }

  selectFilterType(item) {

    console.log(item);

    this.selectedModuleFilterName = item.moduleName;

    if (item.moduleName !== null) {
      if (this.multiSelectGroupFilter == item.moduleName) {
        this.multiSelectGroupFilter.splice(this.multiSelectGroupFilter.indexOf(item.moduleName), 1);
      } else {
        this.newMainModules.foodCourtVendorReviewList = this.moduleDeepCopy.foodCourtVendorReviewList;
        this.multiSelectGroupFilter = item.moduleName;
      }
    } else {
      this.multiSelectGroupFilter = 'All';
    }

    if (item.moduleId == null) {
      this.selectedModuleFilterId = 1;
    } else {
      this.selectedModuleFilterId = item.moduleId;
    }

    this.totalRows = this.newmainModuleList.length;
    this.totalCount = this.newmainModuleList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    console.log(this.multiSelectGroupFilter);
    console.log(this.selectedModuleFilterId);
    this.getPermissionModuleWise();
    this.getDisabledModuleId();
  }

  submitRolePermission() {

    console.log(this.selectedSingleRoleId);
    if (this.selectedSingleRoleId == undefined || this.selectedSingleRoleId == 'undefined') {
      this.appStateSrv.showToast(
        'Please select a role.'
      );
      return;
    }

    // if (this.selectedPermissionArray.length == 0) {
    //   this.appStateSrv.showToast(
    //     'Please select permission type.'
    //   );
    //   return;
    // }


    this.finalSubmissionArrayForRole = this.finalSubmissionArrayForRole.filter((obj, index, self) =>
      index === self.findIndex((t) => (
        t.userRolePermissionId === obj.userRolePermissionId &&
        t.userRoleName === obj.userRoleName
      ))
    );
    this.finalSubmissionArrayForRole = this.finalSubmissionArrayForRole.map(obj => ({ ...obj, createdBy: localStorage.getItem('claAdminId') }));
    console.log(this.finalSubmissionArrayForRole);

    this.finalSubmissionArray = [];
    this.finalSubmissionArray.push({
      "userRolePermissionId": this.selectedSingleRoleId,
      "permissionType": this.selectedPermissionArray == null ? [] : this.selectedPermissionArray,
      "createdBy": localStorage.getItem('claAdminId'),
      "moduleId": this.selectedModuleFilterId,
    });

    const payload = {
      "moduleId": this.selectedModuleFilterId,
      "createdBy": localStorage.getItem('claAdminId'),
      "permissions": this.finalSubmissionArrayForRole
    };

    console.log(payload);


    this.rolepermissionService
      .updateModuleRolePermission(this.finalSubmissionArrayForRole)
      .subscribe((res) => {
        // window.location.reload();
        // this.router.navigate(['/user-role-permission/']);
        this.getPermissionModuleWise();
      });
  }

  openPopoverSort(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  getTheLatestOldestFilter() {

    this.mainRoleLatestTypes.push({
      roleTypeIdSort: null,
      roleTypeNameSort: "Oldest"
    },
      {
        roleTypeIdSort: null,
        roleTypeNameSort: "Latest"
      }
    );
    const allOpt = {
      roleTypeIdSort: null,
      roleTypeNameSort: "All"
    }
    this.mainRoleLatestTypes.unshift(allOpt);
    this.selectedRoleSortName = this.mainRoleLatestTypes[0].roleTypeNameSort;
  }

  selectSurveyTypeSort(item) {

    console.log(item);

    this.selectedRoleSortName = item.roleTypeNameSort;

    if (item.roleTypeNameSort !== null) {
      if (this.multiSelectGroupSort == item.roleTypeNameSort) {
        this.multiSelectGroupSort.splice(this.multiSelectGroupSort.indexOf(item.roleTypeNameSort), 1);
      } else {
        this.newMainUserRoles.list = this.userRoleDeepCopy.list;
        this.multiSelectGroupSort = item.roleTypeNameSort;
      }
    }
    else {
      this.multiSelectGroupSort = 'All';
    }
  }

  sort(property: string, list: any[]) {
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    let direction = this.isDesc ? -1 : 1;

    let sortedArray = list.sort(function (a, b) {
      if (a[property] > b[property]) {
        return -1 * direction;
      } else if (a[property] < b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return sortedArray;
  }

  getPermissionModuleWise() {

    this.roleHasPermission = [];
    this.roleHasEmptyPermission = [];
    this.finalSubmissionArrayForRole = [];

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.rolepermissionService.getModuleWiseRolePermission(this.selectedModuleFilterId).subscribe((res) => {
      if (res?.isValid === true) {
        this.getPermissionDataModuleWise = res?.list;
      } else {
        this.getPermissionDataModuleWise = [];
      }
      console.log(this.getPermissionDataModuleWise);

      //checking permission type
      const idToPermissionType = {};
      this.getPermissionDataModuleWise.forEach(item => {
        idToPermissionType[item.userRolePermissionId] = item.permissionType;
      });
      console.log(idToPermissionType);

      // Checking permissionType for each item in the first array
      this.newmainUserRoleList.forEach(item => {
        const permissionType = idToPermissionType[item.userRolePermissionId];
        if (permissionType === null || permissionType === undefined) {
          this.roleHasEmptyPermission.push(item.userRolePermissionId);
          // console.log(`${item.userRoleName} has empty permissionType`);
        } else {
          this.roleHasPermission.push(item.userRolePermissionId);
          // console.log(`${item.userRoleName} has permissionType: ${permissionType}`);
        }
      });
      console.log('Empty permission', this.roleHasEmptyPermission);
      console.log('Has permission', this.roleHasPermission);
      this.selectedSingleRoleId = this.roleHasPermission.length != 0 ? this.roleHasPermission[0] : '';

      const filteredItem = this.getPermissionDataModuleWise.find(item => item.userRolePermissionId === this.selectedSingleRoleId);
      console.log(filteredItem);
      this.uniqueUserRolePermissionId = filteredItem.userRolePermissionId;
      this.finalSubmissionArrayForRole.push(filteredItem);
      console.log(this.finalSubmissionArrayForRole);
      console.log(this.uniqueUserRolePermissionId);

      if (filteredItem != undefined && filteredItem.permissionType != null && filteredItem.permissionType.length > 0) {
        // const result = this.roleHasPermission.join(",").split(',').map(Number);
        const result = filteredItem.permissionType;
        console.log(result);
        this.newmainRolePermissionList.forEach(day => {
          // Check if the id exists in providedArray
          if (result.includes(day.permissionTypeId)) {
            // If yes, set selected to true
            day.isSelected = true;
          } else {
            // If no, set selected to false
            day.isSelected = false;
          }
          console.log(day);
        });
        this.selectedPermissionArray = filteredItem.permissionType;
        console.log(this.selectedPermissionArray);
      } else {
        this.newmainRolePermissionList = this.newmainRolePermissionList.map(permission => ({
          ...permission,
          isSelected: false
        }));
        this.selectedPermissionArray = [];
      }
    });
  }

  getDisabledModuleId() {

    this.rolepermissionService.getDisablePermissionTypeByModule(this.selectedModuleFilterId).subscribe((res) => {

      console.log(this.selectedModuleFilterId);
      console.log(res);

      if (res?.isValid === true) {
        this.disabledPermission = res?.data.permissionTypes;
        const arr = this.disabledPermission.split(',').map(Number);
        this.newDisabledArray = arr;
        console.log(arr);
        console.log(this.disabledPermission);
      } else {
        this.disabledPermission = []
      }
    });
  }
}

